import React from 'react'
import { Centered, StateMessage, StateTitle } from './PublicPageState.styles'

/**
 * The transient-failure state for public share pages: server errors and network
 * failures land here, NOT on the unavailable state — "unavailable" asserts
 * owner intent (private / not shared), and a backend outage must never
 * masquerade as that. Copy invites a retry because the failure is retryable.
 */
const PublicErrorState: React.FC = () => (
	<Centered>
		<StateTitle>Something went wrong</StateTitle>
		<StateMessage>We couldn&apos;t load this page. Please try again in a moment.</StateMessage>
	</Centered>
)

export default PublicErrorState
